<div class="container p-0" style="width:100%;height:100%;">
      <iframe
        *ngIf="iframeSrc"
        [src]="iframeSrc"
        width="100%"
        height="100%"
        frameBorder="0">
      </iframe>
    </div>